import api from 'api';

const path = 'api/faq';

export default {
    fetch: () => api.get({path})
}
